import Parse from "parse";
const protectedResources = ["User", "Role", "Session"];
const transformIfProtected = (resourceName) => {
  const found = protectedResources.find((r) => r === resourceName);

  return found ? "_" + resourceName : resourceName;
};

const mapToQueryObject = ({ f, resourceFields, query, filter }) => {
  switch (resourceFields[f].type) {
    case "Boolean":
      return query.equalTo(f, filter[f]);
    case "Date":
      return query.greaterThanOrEqualTo(f, new Date(filter[f]));
    case "Pointer":
      return query.equalTo(f, {
        __type: "Pointer",
        className: resourceFields[f].targetClass,
        objectId: filter[f],
      });
    default:
      return query.contains(f, filter[f]);
  }
};

export default ({ URL, APP_ID, JAVASCRIPT_KEY, MASTER_KEY }) => {
  let schemas;
  async function preCompute({ resource }) {
    if (!schemas) {
      schemas = await Parse.Cloud.run("getSchema");
    }
    const resourceTransformed = transformIfProtected(resource);
    const resourceObj = Parse.Object.extend(resourceTransformed);
    const query = new Parse.Query(resourceObj);
    const resourceSchema =
      schemas.find((r) => r.className === resourceTransformed) || {};
    const { fields: resourceFields } = resourceSchema;
    return { resourceFields, query, resourceObj };
  }
  if (Parse.applicationId == null || Parse.javaScriptKey == null) {
    Parse.initialize(APP_ID, JAVASCRIPT_KEY, MASTER_KEY);
    Parse.serverURL = URL;
  }
  return {
    getList: async (resource, params) => {
      const { resourceFields, query, resourceObj } = await preCompute({
        resource,
      });
      const { page, perPage } = params.pagination;
      const { field, order } = params.sort;
      const { filter } = params;

      var relationKey = "";
      relationKey = Object.keys(resourceFields).filter(
        (key) => resourceFields[key].type === "Relation"
      );

      query.limit(perPage);
      query.skip((page - 1) * perPage);

      if (order === "DESC") query.descending(field);
      else if (order === "ASEC") query.ascending(field);
   
      Object.keys(filter).map((f) => {
        if (f.includes("@case")) {
          const fieldName = f.replace("@case", "");
          return query.matches(fieldName, filter[f], "i");
        } else if (f.includes("@equalTo")) {
          const fieldName = f.replace("@equalTo", "");
          return query.equalTo(fieldName, filter[f], "i");
        } else {
          mapToQueryObject({ f, query, resourceFields, filter });
        }
        return null;
      });

      const results = await query.find();
      const count = await query.count();
      const result = results.map((o) => ({ id: o.id, ...o.attributes }));

      if (relationKey.length !== 0) {
        const roles = Parse.Object.extend(
          resourceFields[relationKey].targetClass
        );
        const targetField = `${resource.toString().toLowerCase()}s`;
        const userWithRoles = await Promise.all(
          results.map(async (o) => {
            const userQuery = new Parse.Query(resourceObj);
            const userData = await userQuery.get(o.id);
            const rolesQuery = new Parse.Query(roles);
            rolesQuery.equalTo(targetField, userData);
            const result1 = await rolesQuery.find();
            const r = result1.map((o) => ({ id: o.id, ...o.attributes }));
            const role = r.map((o) => ({ role: o.name }));
            return { id: o.id, role, ...o.attributes };
          })
        );
        return {
          total: count,
          data: userWithRoles,
        };
      }

      return {
        total: count,
        data: result,
      };
    },
    getOne: async (resource, params) => {
      const { resourceFields, query } = await preCompute({ resource });
      // var isRelation=false
      var relationKey = "";
      relationKey = Object.keys(resourceFields).filter(
        (key) =>
          resourceFields[key].type === "Relation" ||
          resourceFields[key].type === "Pointer"
      );
      if (relationKey.length !== 0) {
        const result = await query.get(params.id);

        const data1 = { id: result.id, ...result.attributes };
        return {
          // data: { id: result.id, ...result.attributes }
          data: data1,
        };
      } else {
        const result = await query.get(params.id);
        return {
          data: { id: result.id, ...result.attributes },
        };
      }
    },
    getMany: async (resource, params) => {
      const { resourceObj } = await preCompute({ resource });
      const results = params.ids.map((id) =>
        new Parse.Query(resourceObj).get(id)
      );
      const data = await Promise.all(results);
      return {
        total: data.length,
        data: data.map((o) => ({ id: o.id, ...o.attributes })),
      };
    },
    getManyReference: async (resource, params) => {
      const { query } = await preCompute({ resource });
      const { page, perPage } = params.pagination;
      const { field, order } = params.sort;
      query.contains(params.target, params.id);
      const count = await query.count();
      query.limit(perPage);
      query.skip((page - 1) * perPage);
      if (order === "DESC") query.descending(field);
      else if (order === "ASEC") query.ascending(field);
      const results = await query.find();
      const r = results.map((o) => ({ id: o.id, ...o.attributes }));
      return {
        total: count,
        data: r,
      };
    },
    create: async (resource, params) => {
      const { resourceFields, resourceObj } = await preCompute({ resource });
    
      const resObj = new resourceObj();
      Object.keys(params.data).map((key) => {
        if (resourceFields[key].type === "Pointer") {
          const PointerToRes = Parse.Object.extend(
            resourceFields[key].targetClass
          );
          const pointerToRes = PointerToRes.createWithoutData(
            params.data[key].id
          );
          return resObj.set(key, pointerToRes);
        }
        if (resourceFields[key].type === "File") {
          const parseFile = new Parse.File(key, params.data[key].rawFile);
          return resObj.set(key, parseFile);
        }
        return resObj.set(key, params.data[key]);
      });
      try {
        const r = await resObj.save();
        return { data: { id: r.id, ...r.attributes } };
      } catch (error) {
        console.log(error);
        return error;
      }
    },
    update: async (resource, params) => {
      const { resourceFields, query } = await preCompute({ resource });
      try {
        const obj = await query.get(params.id);
        Object.keys(params.data).map((key) => {
          if (key === "id" || key === "createdAt" || key === "updatedAt") {
            return null;
          }
          if (resourceFields[key].type === "Pointer") {
            const PointerToRes = Parse.Object.extend(
              resourceFields[key].targetClass
            );
            const pointerToRes = PointerToRes.createWithoutData(
              params.data[key].id
            );
            return obj.set(key, pointerToRes);
          }
          if (resourceFields[key].type === "File") {
            if (params.data[key]._url !== undefined && params.data[key]._url !== null) {
              return obj.set(key, params.data[key]);
            } else if (params.data[key]._url === null) {
              const parseFile = new Parse.File(key, params.data[key].rawFile);
              return obj.set(key, parseFile);
            }
          }
          return obj.set(key, params.data[key]);
        });
        const r = await obj.save();
        return { data: { id: r.id, ...r.attributes } };
      } catch (error) {
        throw Error(error.toString());
      }
    },
    updateMany: async (resource, params) => {
      const { resourceObj } = await preCompute({ resource });
      try {
        const qs = await Promise.all(
          params.ids.map((id) => new Parse.Query(resourceObj).get(id))
        );
        qs.map((q) => q.save(params.data));
        return { data: params.ids };
      } catch {
        throw Error("Failed to update all");
      }
    },
    delete: async (resource, params) => {
      const { query } = await preCompute({ resource });
      try {
        const obj = await query.get(params.id);
        const data = { data: { id: obj.id, ...obj.attributes } };
        await obj.destroy();
        return data;
      } catch (error) {
        throw Error("Unable to delete");
      }
    },

    deleteMany: async (resource, params) => {
      const { resourceObj } = await preCompute({ resource });
      try {
        const qs = await Promise.all(
          params.ids.map((id) => new Parse.Query(resourceObj).get(id))
        );
        await Promise.all(qs.map((obj) => obj.destroy()));
        return { data: params.ids };
      } catch (error) {
        throw Error("Unable to delete all");
      }
    },
  };
};

export { Parse };
